import { emToPx } from "../../helpers";
import { ITypographyParameters } from "../../types";

interface IBuiltTypography {
    fontWeight: string;
    fontSize: string;
    letterSpacing: string;
    textDecoration: string;
    lineHeight: string;
}

export const buildTypography = (props: ITypographyParameters): IBuiltTypography => {
    const { fontWeight, fontSize, letterSpacing, textDecoration, lineHeight } = props;

    return {
        fontWeight,
        fontSize: `${fontSize}rem`,
        letterSpacing: `${letterSpacing}rem`,
        textDecoration,
        lineHeight: `${lineHeight}rem`
    };
};

export const buildTypographyInPixels = (props: ITypographyParameters): IBuiltTypography => {
    const { fontWeight, fontSize, letterSpacing, textDecoration, lineHeight } = props;

    return {
        fontWeight,
        fontSize: `${emToPx(fontSize)}px`,
        letterSpacing: `${emToPx(letterSpacing)}px`,
        textDecoration,
        lineHeight: `${emToPx(lineHeight)}px`
    };
};
